require('./group-dish-detail.scss');

const React = require('react');
const Immutable = require('seamless-immutable');
const helper = require('../../../../helper/dish-helper');
const DishDetailHead = require('../dish-detail-head.jsx');
const ChildDish = require('./child-dish.jsx');
const Counter = require('../../../mui/counter.jsx');
const classnames = require('classnames');
const toastIcon = require('../../../../asset/images/warning-white.svg');

import FormattedMessage from '@/intl/formatted-message';
import dishMenuMessages from '../../../../intl/messages/dish-menu';
import buryingPoint, { getPageTypeFromUrl } from '../../../../helper/divolte/register-divolte';

module.exports = React.createClass({
  displayName: 'GroupDishDetail',
  propTypes: {
    dish: React.PropTypes.object.isRequired,
    onAddToCarBtnTap: React.PropTypes.func.isRequired,
    confirmButtonText: React.PropTypes.string,
    showMemberPriceInfo: React.PropTypes.bool,
  },
  getInitialState() {
    const { dish } = this.props;
    const initRulePropertyChecked = dishPropertyTypeInfos =>
      dishPropertyTypeInfos.flatMap(info => {
        if (info.type !== 4) {
          return info;
        }
        return info.update('properties', properties => properties.flatMap(item => item.set('isChecked', true)));
      });

    const dishForDetail = dish
      .setIn(
        ['order'],
        Immutable.from([
          {
            count: 0,
            groups: dish.groups,
          },
        ]),
      )
      .updateIn(
        // process each childDish, if it is default dish, make its order count to its leastCellNum.
        ['order', 0, 'groups'],
        groups =>
          groups.flatMap(group =>
            group.update('childInfos', childDishes => {
              // 设置子菜排序
              const childDishes_ = Immutable.from([].concat(childDishes).sort((a, b) => a.sort - b.sort));
              return childDishes_.flatMap(childDish => {
                const count = childDish.isDefault || childDish.isReplace ? childDish.leastCellNum : 0;
                if (helper.isSingleDishWithoutProps(childDish)) {
                  return childDish.set('isChildDish', true).set('order', count);
                }
                return childDish.set('isChildDish', true).set(
                  'order',
                  Immutable.from([
                    {
                      count,
                      dishPropertyTypeInfos: initRulePropertyChecked(childDish.dishPropertyTypeInfos),
                      dishIngredientInfos: childDish.dishIngredientInfos,
                    },
                  ]),
                );
              });
            }),
          ),
      );
    return {
      activeGroupIdx: 0,
      dish: dishForDetail,
      toast: 0,
      toastText: '',
      groupsValid: true,
      closeModal: true,
      dishModalShow: false,
      childDishExpand: false,
    };
  },

  handleChangeExpand(value) {
    this.setState({ childDishExpand: value });
  },
  componentDidUpdate() {},
  onChildDishChange(targetDish) {
    const { dish } = this.state;
    const activeGroupIdx = parseInt(this.refs.blockIdx.getAttribute('data-blockidx'), 10);

    this.setState({
      activeGroupIdx,
      dish: dish.updateIn(['order', 0, 'groups', activeGroupIdx, 'childInfos'], childInfos =>
        childInfos.flatMap(childDish => (childDish.id === targetDish.id ? targetDish : childDish)),
      ),
    });
  },
  onGroupDishCountChange(increment) {
    const dishForDetail = this.state.dish;
    const { dishIncreaseUnit = 1 } = dishForDetail;
    const oldDishDataForCart = this.props.dish;
    const oldCountForDetail = helper.getDishesCount([dishForDetail]);
    const oldCountForCart = helper.getDishesCount([oldDishDataForCart]);
    let newCountForDetail;
    if (oldCountForDetail === 0 && oldCountForCart === 0) {
      // if never ordered this dish;
      newCountForDetail = dishIncreaseUnit;
    } else if (oldCountForCart === 0 && oldCountForDetail + increment < dishIncreaseUnit) {
      // if never ordered this dish and now want to order a count that is smaller thant dishIncreaseUnit;
      newCountForDetail = 0;
    } else {
      newCountForDetail = oldCountForDetail + increment;
    }
    this.setState({
      dish: dishForDetail.setIn(['order', 0, 'count'], newCountForDetail),
    });
  },
  /**
   * 埋点购物车
   */
  buryingPointAddToCart(dish = {}) {
    try {
      const pageType = getPageTypeFromUrl();
      buryingPoint.send('AddToShoppingCart', { commodityId: dish.id || '', pageType });
    } catch (ex) {
      console.error(ex);
    }
  },
  onAddToCarBtnTap() {
    const { onAddToCarBtnTap } = this.props;
    const { dish } = this.state;
    const firstOrder = dish.order[0];
    const dishCount = helper.getDishesCount([dish]);
    if (!firstOrder) {
      return false;
    }

    if (dishCount <= 0) {
      this.showToast(<FormattedMessage {...dishMenuMessages.chooseGroupDishCount} />);
      return false;
    }

    let invalidRets = [];
    const invalidGroupsIndexes = [];
    firstOrder.groups.forEach((dishGroup, index) => {
      const orderedCount = helper.getDishesCount(helper.getOrderedDishes(dishGroup.childInfos));
      let isValid = true;
      let message = '';

      // 新增判断必须菜是否选够
      dishGroup.childInfos.forEach(replaceDish => {
        if (replaceDish.isReplace) {
          const replaceDishCount = helper.getDishesCount([replaceDish]);
          if (replaceDishCount < replaceDish.leastCellNum) {
            isValid = false;
            message = (
              <FormattedMessage
                {...dishMenuMessages.mushDishCount}
                values={{
                  dishGroupName: dishGroup.name,
                  replaceDishName: replaceDish.name,
                  leastCellNum: replaceDish.leastCellNum,
                }}
              />
            );
            invalidRets.push({ message, isValid });
          }
        }
      });

      if (orderedCount > dishGroup.orderMax) {
        // message = '子菜份数超出可选范围';
        message = <FormattedMessage {...dishMenuMessages.childDishOverMax} values={{ dishGroupName: dishGroup.name }} />;
      } else if (orderedCount < dishGroup.orderMin) {
        // message = '请选择足够的子菜份数';
        message = <FormattedMessage {...dishMenuMessages.childDishLessMin} values={{ dishGroupName: dishGroup.name }} />;
        isValid = false;
        invalidGroupsIndexes.push(index);
      }
      if (!isValid) {
        invalidRets.push({ message, isValid });
        this.setState({ groupsValid: false });
        this.setState({
          activeGroupIdx: Math.min.apply(null, invalidGroupsIndexes),
        });
      }
    });

    if (invalidRets.length) {
      this.showToast(invalidRets.shift().message);
      return false;
    }
    this.buryingPointAddToCart(dish);
    onAddToCarBtnTap(dish, dishCount);
    return true;
  },
  onDishCartModalTap() {
    this.setState({ closeModal: !this.state.closeModal });
  },
  onDishModalShow(state) {
    this.setState({ dishModalShow: state });
  },
  showToast(text) {
    this.setState({ toast: 1, toastText: text });

    setTimeout(() => {
      this.setState({ toast: 0, toastText: '' });
    }, 3000);
  },
  buildDishCounter(dish) {
    if (dish.isVirtualDish) {
      return false;
    }

    if (dish.clearStatus) {
      return (
        <span className="dish-detail-addtocarta-soldout">
          <FormattedMessage {...dishMenuMessages.soldout} />
        </span>
      );
    }

    return (
      <Counter
        step={dish.stepNum || 1}
        minimum={dish.dishIncreaseUnit || 1}
        count={helper.getDishesCount([dish])}
        onCountChange={(count, increment) => this.onGroupDishCountChange(increment)}
        dishItem={dish}
        flag
      />
    );
  },

  buildGroupBlock(forCartModal) {
    const { dish } = this.state;
    const groups = dish.order[0].groups;
    const modalTitleArray = [];

    let groupBlock = groups.map((groupData, idx) => {
      const { id, name, orderMin, orderMax } = groupData;

      const dishCount = helper.getDishesCount(groupData.childInfos);
      if (forCartModal && dishCount > 0) {
        modalTitleArray.push(`${dishCount}份${name}`);
      }

      return !forCartModal || (forCartModal && dishCount > 0) ? (
        <div className="group-block" key={id} data-idx={idx}>
          <div className={classnames('group-block__title')}>
            <strong>{name} </strong>
            <small style={{ float: 'right' }}>
              <FormattedMessage {...dishMenuMessages.picked} />
              <span className="dish-count">{dishCount}</span>
              <FormattedMessage {...dishMenuMessages.dishCount} />/
              <FormattedMessage {...dishMenuMessages.mustChecked} />
              {orderMin !== orderMax ? `${orderMin}~` : false}
              {orderMax}
              <FormattedMessage {...dishMenuMessages.dishCount} />
            </small>
          </div>
          {this.buildGroupDishes(groupData, forCartModal)}
        </div>
      ) : (
        false
      );
    });

    if (forCartModal && modalTitleArray.length > 0) {
      const { closeModal } = this.state;
      return (
        <div className="dish-cart-modal__content">
          <div
            className={classnames('dish-cart-modal__title', {
              'is-open': !closeModal,
            })}
            onTouchTap={this.onDishCartModalTap}
          >
            <label>
              <FormattedMessage {...dishMenuMessages.picked} />
            </label>
            {modalTitleArray.map((subTitle, index) => (
              <span className="dish-cart-modal__title-sub" key={index}>
                {subTitle}
              </span>
            ))}
          </div>
          <div
            className={classnames('dish-cart-modal__block', {
              'dish-cart-modal--hide': closeModal,
            })}
          >
            {groupBlock}
          </div>
        </div>
      );
    }

    return groupBlock;
  },
  buildCartModal() {
    const { closeModal } = this.state;
    return (
      <div className="dish-cart-modal">
        <div
          className={classnames('dish-cart-modal__close', {
            'dish-cart-modal--hide': closeModal,
          })}
          onTouchTap={this.onDishCartModalTap}
        />
        {this.buildGroupBlock(true)}
      </div>
    );
  },

  buildGroupDishes(groupData, forCartModal) {
    if (!groupData) {
      return null;
    }
    let childDishes = groupData.childInfos;
    function divideDishes(dishes) {
      return [].concat.apply(
        [],
        dishes.map(dish => {
          if (helper.isSingleDishWithoutProps(dish)) {
            return [Object.assign({}, dish, { key: `${dish.id}` })];
          }
          return dish.order.map((dishOrder, idx) => Object.assign({}, dish, { key: `${dish.id}-${idx}` }, { order: [Object.assign({}, dishOrder)] }));
        }),
      );
    }
    if (forCartModal) {
      childDishes = divideDishes(groupData.childInfos);
    }

    const remainCount = groupData.orderMax - helper.getDishesCount(groupData.childInfos);
    const { showMemberPriceInfo, dish } = this.props;
    const { isMember = false } = dish;
    return childDishes.map((childDish, index) => {
      const cDish = Immutable.isImmutable(childDish) ? childDish.set('isMember', isMember) : { ...childDish, isMember };
      return (
        <div key={index}>
          <ChildDish
            key={forCartModal ? childDish.key : childDish.id}
            // dish={childDish}
            dish={cDish}
            showMemberPriceInfo={showMemberPriceInfo}
            remainCount={remainCount}
            onDishChange={this.onChildDishChange}
            forCartModal={forCartModal}
            onDishModalShow={this.onDishModalShow}
            showHandleInput={this.props.showHandleInput}
            handleChangeExpand={this.handleChangeExpand}
          />
          {index + 1 === childDishes.length && <div className="o-border--bottom o-border--bottom__modify" />}
        </div>
      );
    });
  },
  render() {
    const { dish, closeModal } = this.state;
    const { confirmButtonText = <FormattedMessage {...dishMenuMessages.addToShoppingCart} />, showMemberPriceInfo } = this.props;

    return (
      <div className="group-dish-detail">
        <div className="dish-detail-close--modify" onTouchTap={event => this.props.onCloseBtnTap(event)}>
          <a className="btn-close" />
        </div>
        <DishDetailHead minimum={1} dish={dish} showMemberPriceInfo={showMemberPriceInfo} onCountChange={this.onGroupDishCountChange} shouldInitCount />
        <div className="dish-detail-title-line">
          <i className="dish-detail-title-line__left" />
          <span>
            <FormattedMessage {...dishMenuMessages.choseGroup} />
          </span>
          <i className="dish-detail-title-line__right" />
        </div>
        <div
          ref="blockIdx"
          className="dishes-container"
          style={{
            flex: 1,
            minHeight: '101%',
            maxHeight: 360,
            webkitOverflowScrolling: this.state.childDishExpand ? 'auto' : 'touch',
          }}
        >
          {this.buildGroupBlock()}
        </div>
        <div className="dish-detail-addtocarta o-flex__fixed o-border--top">
          {this.buildDishCounter(dish)}
          <div style={{ flex: 1 }}>
            <button
              className={classnames('o-btn o-btn--linear', {
                'o-btn--grey': dish.clearStatus,
              })}
              onTouchTap={evt => {
                if (dish.clearStatus) {
                  return false;
                }
                return this.onAddToCarBtnTap();
              }}
            >
              {confirmButtonText}
            </button>
          </div>
        </div>
        {this.state.toast === 1 && (
          <div className="c-toast">
            <div className="c-toast__content">
              <img src={toastIcon} style={{ width: 28 }} alt="" />
              {this.state.toastText}
            </div>
          </div>
        )}
        <div
          className={classnames('dish-cart-modal__close', {
            'dish-cart-modal--hide': closeModal,
          })}
          onTouchTap={this.onDishCartModalTap}
        />
        {this.buildCartModal()}
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./src/component/dish-menu/detail/group-dish-detail/group-dish-detail.jsx